
import * as React from "react";
import { Box } from "@amzn/awsui-components-react-v3";

export function PageNotFound() {
  return <Box variant="h1">Page not found</Box>;
}
